import { StatusBadge, type BadgeTone } from '@/components/StatusBadge';
import type { OrganizationType } from '@/auth/types';

const TONES: Record<OrganizationType, BadgeTone> = {
  基金: 'accent',
  漁協: 'success',
  水産庁: 'info',
  沖縄県: 'warning',
};

/** 組織区分バッジ */
export function OrgBadge({ type }: { type: OrganizationType }) {
  return <StatusBadge tone={TONES[type]}>{type}</StatusBadge>;
}
